import { type DialogItem } from "../types/Dialog.types";

// Helper function to shuffle answers and update correctAnswerIndex
export const shuffleAnswers = (sections: DialogItem[]) => {
    return sections.map((section) => {
    if (!section.answers || section.answers.length === 0) {
        return section;
    }

    // Create array of indices
    const indices = section.answers.map((_: any, index: number) => index);
    
    // Shuffle indices using Fisher-Yates algorithm
    for (let i = indices.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [indices[i], indices[j]] = [indices[j], indices[i]];
    }

    // Shuffle answers array using shuffled indices
    const shuffledAnswers = indices.map((originalIndex: number) => section.answers[originalIndex]);
    
    // Find new index of correct answer
    const originalCorrectIndex = section.correctAnswerIndex;
    const newCorrectIndex = indices.indexOf(originalCorrectIndex);

    return {
        ...section,
        answers: shuffledAnswers,
        correctAnswerIndex: newCorrectIndex,
    };
    });
};